var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.iraEligible)?_c('v-chip',{attrs:{"x-small":""}},[_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v(" mdi-check-bold")]),_vm._v(" IRA ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }